import './Theme.Wrapper.Grid.scss';
export default 'ThemeWrapperGrid';
